import { gql } from "~/__generated__"

// This file is parsed also used by ruby, don't add anything to it aside from this query

export const CURRENT_USER_QUERY_DOCUMENT = gql(`
  query CurrentUserProvider {
    currentUser {
      ...CurrentUser
    }
  }
`)

export const CURRENT_SUBSCRIPTION_FRAGMENT = gql(`
  fragment CurrentSubscription on Subscription {
    id
    status
    tier {
      id
      key
      name
      billingCycle
    }
    createdAt
    currentPeriodStart
    currentPeriodEnd
    cancelAtPeriodEnd
  }
`)

export const CURRENT_USER_FRAGMENT = gql(`
  fragment CurrentUser on User {
    id
    email
    firstName
    lastName
    jobTitle
    isAdmin
    isOnboarded
    agencyBusinessType
    agencyBusinessRelationship
    discarded
    createdAt
    notifyOfNewAgencies
    notifyOfNewCastingCalls
    notifyOfCastingCallSubmissions
    agencyRole
    signupTierKey
    signupBillingCycle
    hasBeenSubscribed
    agency {
      id
      name
      slug
      contactEmail
      agentName
      website
      phone
      logoThumbnailUrl
      hasLogo
      businessType
      businessRelationship
      displayInRosterDatabase
      publicMediaKitEnabled
      publiclyViewable
      robinConnected
      robinConnectPending
      canManageSubscriptions {
        value
        ...AuthorizationError
      }
      canManagePublicMediaKit {
        value
        ...AuthorizationError
      }
    }
    activeSubscription {
      ...CurrentSubscription
    }
    rosterSetupComplete {
      value
      ...AuthorizationError
    }
    canAccessMarketplacePages {
      value
      ...AuthorizationError
    }
    canIndexMyRoster {
      value
      ...AuthorizationError
    }
    canEditBusinessType {
      value
      ...AuthorizationError
    }
    canCreateInfluencer {
      value
      ...AuthorizationError
    }
    canManageRoster {
      value
      ...AuthorizationError
    }
    canIndexCastingCalls {
      value
      ...AuthorizationError
    }
    canIndexAllCastingCalls {
      value
      ...AuthorizationError
    }
    canIndexMyCastingCallSubmissions {
      value
      ...AuthorizationError
    }
    canIndexMyCastingCalls {
      value
      ...AuthorizationError
    }
    canCreateCastingCall {
      value
      ...AuthorizationError
    }
    canInviteUser {
      value
    }
  }
`)
